<template lang="html">
  <div class="kd-toolbar__tools_tool-item">
    <a class="kd-toolbar__icon inline-block-link" @click="toggleSearch" href="javascript:;" aria-label="Toggle Search">
      <i class="kf kf-search"></i>
    </a>
    <div v-if="search_enabled" style="position:relative">
      <input class="kd-toolbar__search_bar" v-model="query" v-focus="true" @keyup.enter="updateValue" @blur="updateOnBlur" @input="update" :maxlength="30" />
      <ul class="dropdown-menu typeahead open" style="width:100%" v-if="hasSuggestions">
        <li v-for="item in items" @click="suggestionClick(item)">
          <a href="javascript:;">{{ item[print_attribute] }}</a>
        </li>
      </ul>
    </div>
    <a class="kd-toolbar__icon inline-block-link" v-if="searchApplied" @click="clearSearch" @mouseover="allow_search_on_blur = false" @mouseout="allow_search_on_blur = true" href="javascript:;">
      <div class="sr-only">Clear the search field:</div>
      <i class="kf kf-x"></i>
    </a>
  </div>
</template>

<script>
  export default {
    props: {
      placeholder: {
        type: String,
        default: 'Search'
      },
      value: {
        type: String,
        default: ''
      },
      // Autocomplete Props //
      autocomplete: {
        type: Boolean,
        default: false
      },
      fetch_func: {
        type: Function
      },
      list: {
        type: Array,
        default:  function () {
          return [];
        }
      },
      debounce: {
        type: Number,
        default: 1E3
      },
      minChars: {
        type: Number,
        default: 2
      },
      query_param: {
        type: String,
        default: 'q'
      },
      limit: {
        type: Number,
        default: 10
      },
      print_attribute: {
        type: String,
        default: 'name'
      },
      mobileView: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        query: '',
        search_enabled: false,
        searched: false,
        timeout: null,
        items: [],
        loading: false,
        allow_search_on_blur: true
      };
    },

    computed: {
      searchApplied() {
        return this.search_enabled && !_.isEmpty(this.query) && this.searched;
      },

      hasSuggestions() {
        return this.items.length > 0
      }

    },

    methods: {

      reset() {
        this.items = [];
        this.allow_search_on_blur = true;
      },

      updateValue() {
        this.$emit('input', this.query)
        this.searched = true
        this.toggleSearch();
        this.reset();
      },

      updateOnBlur() {
        if (this.hasSuggestions) {
          this.items = [];
        }
        if (this.allow_search_on_blur) {
          this.updateValue();
        }
      },

      toggleSearch() {
        if (!this.searchApplied) {
          this.search_enabled = !this.search_enabled;
        }
        
        if (this.mobileView){
          this.$emit('parent-function');
        }
      },
      
      clearSearch() {
        this.query = null;
        this.updateValue(); 
        this.searched = false;
        this.search_enabled = false;
      },

      // Autocomplete Functions //
      debounceFetch() {
        return _.debounce(() => this.update(queryObject), 300, true);
      },

      update() {
        if (!this.autocomplete || (!this.query && !this.list.length)) {
          return;
        }

        if (this.minChars && this.query.length < this.minChars) {
          return;
        }

        this.loading = true;

        const queryObject = { [this.query_param]: this.query };

        this.makeFetchRequest(queryObject);
      },

      makeFetchRequest(queryObject) {
        return this.fetch_func(queryObject)
          .then((response) => {
            let data = response || response.data || response.body;

            this.items = this.limit ?
              data.slice(0, this.limit) :
              data;

            this.loading = false;
          });
      },

      suggestionClick(item) {
        this.query = item[this.print_attribute];
        this.selected = item;
        this.reset();
      }
    }
  }
</script>